<script>
import isCondition from "@utils/is-condition";
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";

export default {
  props: {
    dataList: {
      type: Array,
      default: () => [
        {
          type: 'text', // ['text', 'description', 'hr', 'slot',]
          title: '1<i class="fontello fontello-paw fa-fw ml-2 text-primary"></i>', // type:text 必填
          text: 'NT$ 800', // type:text | description  必填
          class: '',
          titleClass: '',
          textClass: 'font-number',
          category: "",
          condition: () => {
            return true;
          },
          slot: '', // type:slot 必填
        }
      ]
    },
    type: {
      type: String,
      default: 'info',
      validator(value) {
        return [
          'info',
          'bill',
          'order',
          'deposit'
        ].includes(value)
      },
    },
  },
  methods: {
    isCondition,
    formatTextUpperCasefirst
  }
}
</script>
<!-- section template -->
<template>
  <ul :class="[$style.baseList, $style[`isStyle${formatTextUpperCasefirst(type)}`]]">
    <template v-for="(item, index) in dataList">
      <li
        :key="`dataList-${index}`"
        :class="item.class"
        class="baseList__item"
      >
        <template v-if="!item.type || item.type === 'text'">
          <div v-if="item.category === 'goods'" class="w-100">
            <div v-if="item.store" class="isSmall mr-2 el-tag el-tag--light isStyleGray isRadius-0">{{ item.store.title }}</div>
            <div class="baseList__title my-2" >
              <span class="title" v-html="item.title"></span><span>x{{ item.qty }}</span>
              <div
                :class="item.textClass"
                class="baseList__text"
                v-html="item.text"
              ></div>
            </div>
            <div v-if="item.spec" class="isSpec">
              <div v-for="(sp, i) in item.spec" :key="i" class="baseList__text">
                {{ sp.title }} : <span v-for="(v, _i) in sp.values" :key="_i">{{ v.title }}<i v-if="_i < sp.values.length - 1">、</i></span><i v-if="i < item.spec.length - 1"> | </i> 
              </div>
            </div>
          </div>
          <div v-else class="baseList__item w-100">
            <div
              :class="item.titleClass"
              class="baseList__title"
              v-html="item.title"
            ></div>
            <div
              :class="item.textClass"
              class="baseList__text"
              v-html="item.text"
            ></div>
          </div>
        </template>
        <template v-if="item.type === 'description'">
          <div
            :class="item.textClass"
            class="baseList__description"
            v-html="item.text"
          ></div>
        </template>
        <template v-if="item.type === 'hr'">
          <hr class="baseList__hr">
        </template>
        <template v-if="item.type === 'slot'">
          <slot :name="item.slot"/>
        </template>
      </li>
    </template>
  </ul>
</template>
<!-- section style -->
<style lang="scss" module>
.baseList {
  @include list-unstyled;

  :global {
    .baseList {
      @include unstyled;
    }
  }

  &.isStyleInfo {
    margin-bottom: -1rem;

    :global {
      .baseList {
        &__item {
          display: flex;
          align-items: center;
          margin-bottom: 0.75rem;
          line-height: 1.5;
          color: $color-gray-2;
          // font-size: 0.875rem;
        }

        &__title {
          &::after {
            content: '：';
          }
        }

        &__text {
          @include unstyled;
        }

        &__description {
          line-height: 1.75;
        }

        &__hr {
          width: 100%;
          margin: 0.5rem 0;
        }
      }
    }
  }

  &.isStyleBill {
    color: $color-gray-2;

    :global {
      .baseList {
        &__item {
          display: flex;
          justify-content: space-between;
          padding: 0.2rem;
          font-size: 0.875rem;
          line-height: 1.5;
          color: $color-gray-2;
          font-size: 0.875rem;
        }

        &__title {
          @include unstyled;
          
        }

        &__text {
          white-space: nowrap;
          text-align: right;
        }

        &__description {
          line-height: 1.75;
        }

        &__hr {
          width: 100%;
          margin: 0.5rem 0;
        }
      }
    }
  }

  &.isStyleOrder {
    margin-bottom: -1rem;

    :global {
      .baseList {
        &__item {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          padding: 0.25rem 0 0.75rem;
          line-height: 1.5;
          color: $color-gray-2;
          font-size: 0.875rem;
          .isSpec {
            display: flex;
            flex-wrap: wrap;
            .baseList__text {
              color: #646A6F;
              font-size: 0.75rem;
            }
          }
        }

        &__title {
          @include unstyled;
        }

        &__text {
          white-space: nowrap;
          text-align: right;
        }

        &__description {
          line-height: 1.75;
        }

        &__hr {
          width: 100%;
          margin: 0rem 0;
          border-top: 1px dashed $color-line;
        }
      }
      .isGoods {
        .baseList__title {
          display: flex;
          justify-content: space-between;
          .title {
            min-width: 50%;
          }
        }
      }
    }
  }
}
</style>
